import { useAuthContext } from "./useAuthContext";

export const useAdminLogout = () => {

    const { dispatch } = useAuthContext();
  
    const logout = () => {
     //remove user from local storage
     localStorage.removeItem('adminuser');
     //dispatch logout action
     dispatch({type: 'ADMIN_LOGOUT'});
    }
    return { logout };
}
